var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4167C0 7.65399 1.09747 5.00447 3.05097 3.05097C5.00447 1.09747 7.65399 0 10.4167 0H39.5833C42.346 0 44.9955 1.09747 46.949 3.05097C48.9025 5.00447 50 7.65399 50 10.4167V39.5833C50 42.346 48.9025 44.9955 46.949 46.949C44.9955 48.9025 42.346 50 39.5833 50H10.4167C7.65399 50 5.00447 48.9025 3.05097 46.949C1.09747 44.9955 0 42.346 0 39.5833V10.4167Z",
    fill: "url(#paint0_radial_11516_69742)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2753 45.3293C47.3255 46.7656 46.0344 47.944 44.5176 48.7591C43.0008 49.5742 41.3056 50.0006 39.5837 50.0001H10.417C8.69506 50.0006 6.99985 49.5742 5.48304 48.7591C3.96624 47.944 2.67517 46.7656 1.72534 45.3293L19.992 27.0626C21.3204 25.7344 23.1219 24.9883 25.0003 24.9883C26.8788 24.9883 28.6803 25.7344 30.0087 27.0626L48.2753 45.3293Z",
    fill: "url(#paint1_linear_11516_69742)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5827 14.592C39.5827 15.6993 39.1428 16.7612 38.3598 17.5442C37.5769 18.3271 36.5149 18.767 35.4077 18.767C34.3004 18.767 33.2385 18.3271 32.4555 17.5442C31.6725 16.7612 31.2327 15.6993 31.2327 14.592C31.2327 13.4847 31.6725 12.4228 32.4555 11.6398C33.2385 10.8569 34.3004 10.417 35.4077 10.417C36.5149 10.417 37.5769 10.8569 38.3598 11.6398C39.1428 12.4228 39.5827 13.4847 39.5827 14.592Z",
    fill: "url(#paint2_linear_11516_69742)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11516_69742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-19.6417 -28.125) rotate(51.6869) scale(138.258 125.755)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#0FAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#367AF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11516_69742",
    x1: 17.8587,
    y1: 24.9876,
    x2: 23.217,
    y2: 51.4459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CD0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11516_69742",
    x1: 33.7368,
    y1: 9.48783,
    x2: 36.7868,
    y2: 20.4712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.cc3eaa71f11f16c79623a78563379997.svg";
export { ForwardRef as ReactComponent };